import React from "react"
import { Grid, Typography, styled } from "@mui/material"

import { colors } from "theme"

interface PersonType {
  name: string
  phone: string
  email: string
}

type Props = React.HTMLAttributes<HTMLDivElement> & {
  title: string
  person: PersonType
}

const PersonComponent = ({ title, person }: Props) => {
  const { name, phone, email } = person

  return (
    <>
      {person && (
        <Container
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Item>
            <Typography component="span" variant="body1">
              {title}
            </Typography>
            <Typography component="span" variant="body2" align="right">
              {name}
            </Typography>
          </Item>
          <Item>
            <span />
            <Typography component="span" variant="body2" align="right">
              {phone}
              {email && (
                <>
                  <br />
                  {email}
                </>
              )}
            </Typography>
          </Item>
        </Container>
      )}
    </>
  )
}

export default PersonComponent

const Container = styled(Grid)(() => ({
  padding: "0",
  margin: "0",
}))

const Item = styled(Grid)(() => ({
  borderBottom: `1px solid ${colors.cultured}`,
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  padding: "7px 0",
  width: "100%",
  "&:last-child": {
    border: "none",
  },
}))
